import { isAuth } from "@/utils/api";
import { getLastAuthRoute } from "@/utils/lastAuthRoute";
import { getSafeRedirectURL } from "@/utils/url";
import Cookies from "js-cookie";
import { LoaderFunctionArgs, redirect } from "react-router-dom";

export const guestLoader = ({ request }: LoaderFunctionArgs) => {
  if (isAuth() || Cookies.get("admin-refresh-token")) {
    const redirectUrl = new URL(request.url).searchParams.get("redirectUrl");
    const fallback = getSafeRedirectURL(getLastAuthRoute());
    return redirect(getSafeRedirectURL(redirectUrl, fallback));
  }
  return null;
};
